export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

export const ALLOWED_FILE_TYPES = [
  'text/plain',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
